export default __webpack_public_path__ + "static/media/spotify.df1b132a.svg";